/* eslint-disable array-callback-return */
import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { colors } from "../../../common/Theme/Colors";
import { userTypes } from "../../../common/users/userTypes";
import { StyledTypography } from "../../../common/Utils/StyledComponents";
import { useMomDetailMutation } from "../../../request/Mom";
import Translate from "../../../translation/utils/translateFunction";
import PageHeader from "../../common/pageHeader";
import CommonImage from "../../ImageGallery/CommonImage";
import NoDataFound from "../../ManageTask/NoDataFound";
import Loader from "../../staff/Owner/LoadingComp";
import VoiceNotes from "../../VoiceNotes/Components/VoiceNotes";

const MomDetailView = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { userData } = useSelector((state) => state.formanagement);
  const [points, setPoints] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [images, setImages] = useState([]);
  const [voiceNoteObj, setVoiceNoteObj] = useState();
  const [getMomDetail, { data: serverResponse, isSuccess, isLoading }] =
    useMomDetailMutation();

  useEffect(() => {
    if (state) {
      getMomDetail({ eventMomId: state?.eventid });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);
  useEffect(() => {
    if (isSuccess && serverResponse?.data) {
      const { notes, attachment, isAttachment, voiceNote } =
        serverResponse?.data;
      setPoints(notes);
      isAttachment &&
        attachment?.length > 0 &&
        attachment.map((attachmentItem) => {
          const { eventMomFileName } = attachmentItem;
          const obj = {
            name: eventMomFileName,
            path: eventMomFileName,
            ...attachmentItem,
          };
          attachments.push(obj);
          images.push(attachmentItem?.url);
        });
      setAttachments([...attachments]);
      setImages([...images]);
      const voiceObj = {
        byteCode: voiceNote.buffer,
        timeLength: voiceNote.timeLength,
        // timeLengthInSec: voiceNote.timeLengthInSec?.toString(),
        src: voiceNote.url,
        createdAt: voiceNote.recordedTimeDateObject,
      };
      !!voiceNote?.buffer?.length && setVoiceNoteObj(voiceObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  const EditAndLinkedItem = () => (
    <>
      <div
        className="cursor-pointer dropdown-item"
        onClick={() =>
          navigate("/mom/myevent/editEvent", {
            state: {
              data: serverResponse?.data,
              isEdit: true,
              isMyMom: state?.isMyMom,
            },
          })
        }
      >
        {Translate("common:editToolTip")}
      </div>
      <div className="dropdown-divider" />
      <div
        className="cursor-pointer dropdown-item"
        onClick={() =>
          navigate("/calendar/viewEvent", {
            state: {
              eventId: serverResponse?.data?.eventId,
              isMOM: true,
            },
          })
        }
      >
        {Translate("momPage:viewLinkedEvents")}
      </div>
      {userData?.role.type?.toLowerCase() !== userTypes.Po?.toLowerCase() && (
        <div className="dropdown-divider" />
      )}
    </>
  );

  const SharedUserItem = () => (
    <div
      className="cursor-pointer dropdown-item"
      onClick={() =>
        navigate(
          `/mom/${state?.isShared ? "sharedWithMe" : "myevent"}/sharedUsers`,
          {
            state: serverResponse?.data?._id,
          }
        )
      }
    >
      {Translate("momPage:sharedUsersTitle")}
    </div>
  ); //sharedWithMe

  return (
    <div className="row container_spacing">
      <div className="card card_spacing">
        <PageHeader
          title={Translate("momPage:detailHeader")}
          onClick={() => navigate(-1)}
          RightContainer={() =>
            !serverResponse?.data?.hasEditPermission &&
            userData?.role.type?.toLowerCase() ===
              userTypes.Po?.toLowerCase() ? (
              <></>
            ) : (
              <Stack className="card-options menuOptions">
                <a
                  href="/#"
                  className="nav-link dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ marginLeft: 0, marginRight: 0 }}
                >
                  <i className="fa fa-caret-down manageIconColor menuOptionsIcon" />
                </a>
                <div className="dropdown-menu dropdownAlignment">
                  {serverResponse?.data?.hasEditPermission ? (
                    <>
                      <EditAndLinkedItem />
                      {userData?.role.type?.toLowerCase() !==
                        userTypes.Po?.toLowerCase() && <SharedUserItem />}
                    </>
                  ) : (
                    <SharedUserItem />
                  )}
                </div>
              </Stack>
            )
          }
        />
        <div className="card-body">
          <Stack sx={{ backgroundColor: "#e9ecef" }} p={3}>
            {points.map((item) => (
              <Stack flexDirection={"row"} alignItems={"center"}>
                <div
                  style={{
                    width: 5,
                    height: 5,
                    borderRadius: 2.5,
                    marginRight: 5,
                    backgroundColor: colors.black,
                  }}
                />
                <StyledTypography sx={{ width: "98%" }}>
                  {item}
                </StyledTypography>
              </Stack>
            ))}
          </Stack>

          <StyledTypography className="taskHeading font-16" pt={3}>
            {Translate("manageTask:voiceNoteTitle")}
          </StyledTypography>

          <Stack
            className="CommentCard_spacing"
            sx={{ backgroundColor: "#e9ecef" }}
            p={3}
          >
            {voiceNoteObj?.src || voiceNoteObj?.timeLength ? (
              <div style={{ width: 450 }}>
                <VoiceNotes
                  voiceObj={voiceNoteObj}
                  className={"voiceNote_spacing"}
                />
              </div>
            ) : (
              !isLoading && (
                <NoDataFound
                  message={Translate("manageTask:noVoiceNote")}
                  isCenter
                  className="NoDataStyle"
                />
              )
            )}
          </Stack>

          <StyledTypography className="taskHeading font-16" pt={3}>
            {Translate("manageTask:attacheMenttitle")}
          </StyledTypography>

          <Stack
            className="CommentCard_spacing"
            sx={{ backgroundColor: "#e9ecef" }}
            p={3}
          >
            {attachments.length > 0 ? (
              <div className="AttachmentBoxStyling">
                <CommonImage images={images} files={attachments} icon={true} />
              </div>
            ) : (
              !isLoading && (
                <NoDataFound
                  message={Translate("manageTask:noAttachmentMsg")}
                  isCenter
                  className="NoDataStyle"
                />
              )
            )}
          </Stack>
        </div>
        <Loader loading={isLoading} />
      </div>
    </div>
  );
};
export default MomDetailView;
